import { 
    ROLE_GET_REQUEST, ROLE_GET_SUCCESS, ROLE_GET_ERROR, 
    ROLE_GET_BY_KEY_REQUEST, ROLE_GET_BY_KEY_SUCCESS, ROLE_GET_BY_KEY_ERROR, 
    ROLE_ADD_REQUEST, ROLE_ADD_SUCCESS, ROLE_ADD_ERROR, 
    ROLE_EDIT_REQUEST, ROLE_EDIT_SUCCESS, ROLE_EDIT_ERROR, 
    ROLE_DELETE_REQUEST, ROLE_DELETE_SUCCESS, ROLE_DELETE_ERROR
} from "../constants/roleConstants";

const initialState = {
    roles: [],
    role: {},
    loading: false,
    success: null,
    error: null,
    roleRequestedCount: 0,
};

export const roleReducer = (state = initialState, action) => {
    switch (action.type)     {
        case ROLE_GET_REQUEST:
            return {
                ...state,
                roleRequestedCount: ++state.roleRequestedCount,
                loading: true,
            };
        case ROLE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                roles: action.payload,
                success: true,
            };
        case ROLE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ROLE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ROLE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                role: action.payload,
                success: true,
            };
        case ROLE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ROLE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ROLE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case ROLE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ROLE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ROLE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case ROLE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ROLE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ROLE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case ROLE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
